import React from 'react';
import { Link } from 'react-router-dom';
import NotificationButton from './NotificationButton';
import HamburgerMenu from './menu/HamburgerMenu';
import SiteLogo from './SiteLogo';
import useReducedMotion from '../hooks/useReducedMotion';

const Header = ({ darkMode, onToggleTheme, contained = false }) => {
  const reduceMotion = useReducedMotion();

  return (
    <header
      className={`bg-white dark:bg-dark shadow-sm pb-2 border-b border-gray-200/80 dark:border-gray-700/60 sticky top-0 z-30 lg:static lg:z-auto${
        // Next to DesktopSidebar the sidebar head carries logo and bell
        contained ? ' lg:hidden' : ''
      }`}
      style={{ paddingTop: 'max(0.5rem, env(safe-area-inset-top, 0px))' }}
    >
      <div className="container-narrow flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="text-xl font-bold text-primary" aria-label="Main-Bet home">
            <span className="flex h-11 items-center">
              <SiteLogo className="h-8 w-auto" />
            </span>
          </Link>
        </div>

        <div className="flex items-center space-x-2">
          <NotificationButton reduceMotion={reduceMotion} />
          <HamburgerMenu
            reduceMotion={reduceMotion}
            darkMode={darkMode}
            onToggleTheme={onToggleTheme}
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
